import rootReducer from './Reducers';

const globalReducer = (state = {}, action) => {
    return {
        root: rootReducer(state.root, action),
    };
};

export default globalReducer;
